import { gql } from '@apollo/client';

const LeadershipQueryHi = gql`
  query MyQuery {
    nodeLeaderships(first: 20, langcode: "hi") {
      nodes {
        id
        path
        post
        shortDescription
        title
        commonBanner {
          ... on MediaCommonBanner {
            id
            name
            mediaImage2 {
            url
            alt
          }
          }
        }
        imageAbout {
          url
          alt
        }
        group {
          ... on TermPost {
            id
            name
          }
        }
        body {
          value
        }
      }
    }
  }
`;

export default LeadershipQueryHi;
